export default {
// 时间格式化
    timeFormat (val) {
        return val >= 10 ? val : '0' + val
    },
    // 数组深拷贝
    arrClone (arr) {
        return [...arr]
    },
    // 对象深拷贝
    objClone (obj) {
        return JSON.parse(JSON.stringify(obj))
    },
    // 正则判断微信号
    isWeiXin (str) {
        return /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/.test(str)
    },
    // 正则判断手机号
    isPhone (str) {
        return /^(13[0-9]|14[5|7|9]|15[0|1|2|3|5|6|7|8|9]|16[2|5|6|7]|17[0|1|2|3|5|6|7|8]|18[0-9]|19[1|3|5|8|9])\d{8}$/.test(str)
        // return /^(?:\(?[0\+]\d{2,3}\)?)[\s-]?(?:(?:\(0{1,3}\))?[0\d]{1,4})[\s-](?:[\d]{7,8}|[\d]{3,4}[\s-][\d]{3,4})\d{8}$/.test(str)
        
    },
    
    // 正则判断是否全是中文
    isZhCn (str) {
        return /^[\u4E00-\u9FA5]+$/.test(str)
    },
    // 正则判断中文姓名
    isZhCnName (str) {
        return /^[\u4E00-\u9FA5]{2,25}$/.test(str)
    },
    // 正则六位数字
    isPayNumber (str) {
        return /^\d{6}$/.test(str)
    },
    // 正则邮箱
    isEmail (str) {
        return /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(str)
    },
    // 正则银行卡
    isBankCard (str) {
        return /^[1-9]\d{9,29}$/.test(str)
    },
    // 正则身份证
    isIdentityCard (str) {
        return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str)
    },
  // 正则去除特殊字符
    isSpecialCha (str) {
        return str.replace(/[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s%]/g, '')
    },
}


// WEBPACK FOOTER //
// ./src/assets/js/public.js